export default "__VITE_PUBLIC_ASSET__fb4e7b76__"